// Format for each row:
// [ constant, coinSymbol, coinName ]
module.exports = [
  [0x80_00_00_00, 'BTC', 'Bitcoin'],
  [0x80_00_00_01, '', 'Testnet (all coins)'],
  [0x80_00_00_02, 'LTC', 'Litecoin'],
  [0x80_00_00_03, 'DOGE', 'Dogecoin'],
  [0x80_00_00_04, 'RDD', 'Reddcoin'],
  [0x80_00_00_05, 'DASH', 'Dash'],
  [0x80_00_00_06, 'PPC', 'Peercoin'],
  [0x80_00_00_07, 'NMC', 'Namecoin'],
  [0x80_00_00_08, 'FTC', 'Feathercoin'],
  [0x80_00_00_09, 'XCP', 'Counterparty'],
  [0x80_00_00_0a, 'BLK', 'Blackcoin'],
  [0x80_00_00_0b, 'NSR', 'NuShares'],
  [0x80_00_00_0c, 'NBT', 'NuBits'],
  [0x80_00_00_0d, 'MZC', 'Mazacoin'],
  [0x80_00_00_0e, 'VIA', 'Viacoin'],
  [0x80_00_00_0f, 'XCH', 'ClearingHouse'],
  [0x80_00_00_10, 'RBY', 'Rubycoin'],
  [0x80_00_00_11, 'GRS', 'Groestlcoin'],
  [0x80_00_00_12, 'DGC', 'Digitalcoin'],
  [0x80_00_00_13, 'CCN', 'Cannacoin'],
  [0x80_00_00_14, 'DGB', 'DigiByte'],
  [0x80_00_00_15, '', 'Open Assets'],
  [0x80_00_00_16, 'MONA', 'Monacoin'],
  [0x80_00_00_17, 'CLAM', 'Clams'],
  [0x80_00_00_18, 'XPM', 'Primecoin'],
  [0x80_00_00_19, 'NEOS', 'Neoscoin'],
  [0x80_00_00_1a, 'JBS', 'Jumbucks'],
  [0x80_00_00_1b, 'ZRC', 'ziftrCOIN'],
  [0x80_00_00_1c, 'VTC', 'Vertcoin'],
  [0x80_00_00_1d, 'NXT', 'NXT'],
  [0x80_00_00_1e, 'BURST', 'Burst'],
  [0x80_00_00_1f, 'MUE', 'MonetaryUnit'],
  [0x80_00_00_20, 'ZOOM', 'Zoom'],
  [0x80_00_00_21, 'VASH', 'Virtual Cash'],
  [0x80_00_00_22, 'CDN', 'Canada eCoin'],
  [0x80_00_00_23, 'SDC', 'ShadowCash'],
  [0x80_00_00_24, 'PKB', 'ParkByte'],
  [0x80_00_00_25, 'PND', 'Pandacoin'],
  [0x80_00_00_26, 'START', 'StartCOIN'],
  [0x80_00_00_27, 'MOIN', 'MOIN'],
  [0x80_00_00_28, 'EXP', 'Expanse'],
  [0x80_00_00_29, 'EMC2', 'Einsteinium'],
  [0x80_00_00_2a, 'DCR', 'Decred'],
  [0x80_00_00_2b, 'XEM', 'NEM'],
  [0x80_00_00_2c, 'PART', 'Particl'],
  [0x80_00_00_2d, 'ARG', 'Argentum (dead)'],
  [0x80_00_00_2e, '', 'Libertas'],
  [0x80_00_00_2f, '', 'Posw coin'],
  [0x80_00_00_30, 'SHR', 'Shreeji'],
  [0x80_00_00_31, 'GCR', 'Global Currency Reserve (GCRcoin)'],
  [0x80_00_00_32, 'NVC', 'Novacoin'],
  [0x80_00_00_33, 'AC', 'Asiacoin'],
  [0x80_00_00_34, 'BTCD', 'BitcoinDark'],
  [0x80_00_00_35, 'DOPE', 'Dopecoin'],
  [0x80_00_00_36, 'TPC', 'Templecoin'],
  [0x80_00_00_37, 'AIB', 'AIB'],
  [0x80_00_00_38, 'EDRC', 'EDRCoin'],
  [0x80_00_00_39, 'SYS', 'Syscoin'],
  [0x80_00_00_3a, 'SLR', 'Solarcoin'],
  [0x80_00_00_3b, 'SMLY', 'Smileycoin'],
  [0x80_00_00_3c, 'ETH', 'Ether'],
  [0x80_00_00_3d, 'ETC', 'Ether Classic'],
  [0x80_00_00_3e, 'PSB', 'Pesobit'],
  [0x80_00_00_3f, 'LDCN', 'Landcoin (dead)'],
  [0x80_00_00_40, '', 'Open Chain'],
  [0x80_00_00_41, 'XBC', 'Bitcoinplus'],
  [0x80_00_00_42, 'IOP', 'Internet of People'],
  [0x80_00_00_43, 'NXS', 'Nexus'],
  [0x80_00_00_44, 'INSN', 'InsaneCoin'],
  [0x80_00_00_45, 'OK', 'OKCash'],
  [0x80_00_00_46, 'BRIT', 'BritCoin'],
  [0x80_00_00_47, 'CMP', 'Compcoin'],
  [0x80_00_00_48, 'CRW', 'Crown'],
  [0x80_00_00_49, 'BELA', 'BelaCoin'],
  [0x80_00_00_4a, 'ICX', 'ICON'],
  [0x80_00_00_4b, 'FJC', 'FujiCoin'],
  [0x80_00_00_4c, 'MIX', 'MIX'],
  [0x80_00_00_4d, 'XVG', 'Verge Currency'],
  [0x80_00_00_4e, 'EFL', 'Electronic Gulden'],
  [0x80_00_00_4f, 'CLUB', 'ClubCoin'],
  [0x80_00_00_50, 'RICHX', 'RichCoin'],
  [0x80_00_00_51, 'POT', 'Potcoin'],
  [0x80_00_00_52, 'QRK', 'Quarkcoin'],
  [0x80_00_00_53, 'TRC', 'Terracoin'],
  [0x80_00_00_54, 'GRC', 'Gridcoin'],
  [0x80_00_00_55, 'AUR', 'Auroracoin'],
  [0x80_00_00_56, 'IXC', 'IXCoin'],
  [0x80_00_00_57, 'NLG', 'Gulden'],
  [0x80_00_00_58, 'BITB', 'BitBean'],
  [0x80_00_00_59, 'BTA', 'Bata'],
  [0x80_00_00_5a, 'XMY', 'Myriadcoin'],
  [0x80_00_00_5b, 'BSD', 'BitSend'],
  [0x80_00_00_5c, 'UNO', 'Unobtanium'],
  [0x80_00_00_5d, 'MTR', 'MasterTrader'],
  [0x80_00_00_5e, 'GB', 'GoldBlocks'],
  [0x80_00_00_5f, 'SHM', 'Saham'],
  [0x80_00_00_60, 'CRX', 'Chronos'],
  [0x80_00_00_61, 'BIQ', 'Ubiquoin'],
  [0x80_00_00_62, 'EVO', 'Evotion'],
  [0x80_00_00_63, 'STO', 'SaveTheOcean'],
  [0x80_00_00_64, 'BIGUP', 'BigUp'],
  [0x80_00_00_65, 'GAME', 'GameCredits'],
  [0x80_00_00_66, 'DLC', 'Dollarcoins'],
  [0x80_00_00_67, 'ZYD', 'Zayedcoin'],
  [0x80_00_00_68, 'DBIC', 'Dubaicoin'],
  [0x80_00_00_69, 'STRAT', 'Stratis'],
  [0x80_00_00_6a, 'SH', 'Shilling'],
  [0x80_00_00_6b, 'MARS', 'MarsCoin'],
  [0x80_00_00_6c, 'UBQ', 'Ubiq'],
  [0x80_00_00_6d, 'PTC', 'Pesetacoin'],
  [0x80_00_00_6e, 'NRO', 'Neurocoin'],
  [0x80_00_00_6f, 'ARK', 'ARK'],
  [0x80_00_00_70, 'USC', 'UltimateSecureCashMain'],
  [0x80_00_00_71, 'THC', 'Hempcoin'],
  [0x80_00_00_72, 'LINX', 'Linx'],
  [0x80_00_00_73, 'ECN', 'Ecoin'],
  [0x80_00_00_74, 'DNR', 'Denarius'],
  [0x80_00_00_75, 'PINK', 'Pinkcoin'],
  [0x80_00_00_76, 'ATOM', 'Atom'],
  [0x80_00_00_77, 'PIVX', 'Pivx'],
  [0x80_00_00_78, 'FLASH', 'Flashcoin'],
  [0x80_00_00_79, 'ZEN', 'Zencash'],
  [0x80_00_00_7a, 'PUT', 'Putincoin'],
  [0x80_00_00_7b, 'ZNY', 'BitZeny'],
  [0x80_00_00_7c, 'UNIFY', 'Unify'],
  [0x80_00_00_7d, 'XST', 'StealthCoin'],
  [0x80_00_00_7e, 'BRK', 'Breakout Coin'],
  [0x80_00_00_7f, 'VC', 'Vcash'],
  [0x80_00_00_80, 'XMR', 'Monero'],
  [0x80_00_00_81, 'VOX', 'Voxels'],
  [0x80_00_00_82, 'NAV', 'NavCoin'],
  [0x80_00_00_83, 'FCT', 'Factom Factoids'],
  [0x80_00_00_84, 'EC', 'Factom Entry Credits'],
  [0x80_00_00_85, 'ZEC', 'Zcash'],
  [0x80_00_00_86, 'LSK', 'Lisk'],
  [0x80_00_00_87, 'STEEM', 'Steem'],
  [0x80_00_00_88, 'XZC', 'ZCoin'],
  [0x80_00_00_89, 'RBTC', 'RSK'],
  [0x80_00_00_8a, '', 'Giftblock'],
  [0x80_00_00_8b, 'RPT', 'RealPointCoin'],
  [0x80_00_00_8c, 'LBC', 'LBRY Credits'],
  [0x80_00_00_8d, 'KMD', 'Komodo'],
  [0x80_00_00_8e, 'BSQ', 'bisq Token'],
  [0x80_00_00_8f, 'RIC', 'Riecoin'],
  [0x80_00_00_90, 'XRP', 'Ripple'],
  [0x80_00_00_91, 'BCH', 'Bitcoin Cash'],
  [0x80_00_00_92, 'NEBL', 'Neblio'],
  [0x80_00_00_93, 'ZCL', 'ZClassic'],
  [0x80_00_00_94, 'XLM', 'Stellar Lumens'],
  [0x80_00_00_95, 'NLC2', 'NoLimitCoin2'],
  [0x80_00_00_96, 'WHL', 'WhaleCoin'],
  [0x80_00_00_97, 'ERC', 'EuropeCoin'],
  [0x80_00_00_98, 'DMD', 'Diamond'],
  [0x80_00_00_99, 'BTM', 'Bytom'],
  [0x80_00_00_9a, 'BIO', 'Biocoin'],
  [0x80_00_00_9b, 'XWCC', 'Whitecoin Classic'],
  [0x80_00_00_9c, 'BTG', 'Bitcoin Gold'],
  [0x80_00_00_9d, 'BTC2X', 'Bitcoin 2x'],
  [0x80_00_00_9e, 'SSN', 'SuperSkynet'],
  [0x80_00_00_9f, 'TOA', 'TOACoin'],
  [0x80_00_00_a0, 'BTX', 'Bitcore'],
  [0x80_00_00_a1, 'ACC', 'Adcoin'],
  [0x80_00_00_a2, 'BCO', 'Bridgecoin'],
  [0x80_00_00_a3, 'ELLA', 'Ellaism'],
  [0x80_00_00_a4, 'PIRL', 'Pirl'],
  [0x80_00_00_a5, 'XNO', 'Nano'],
  [0x80_00_00_a6, 'VIVO', 'Vivo'],
  [0x80_00_00_a7, 'FRST', 'Firstcoin'],
  [0x80_00_00_a8, 'HNC', 'Helleniccoin'],
  [0x80_00_00_a9, 'BUZZ', 'BUZZ'],
  [0x80_00_00_aa, 'MBRS', 'Ember'],
  [0x80_00_00_ab, 'HC', 'Hcash'],
  [0x80_00_00_ac, 'HTML', 'HTMLCOIN'],
  [0x80_00_00_ad, 'ODN', 'Obsidian'],
  [0x80_00_00_ae, 'ONX', 'OnixCoin'],
  [0x80_00_00_af, 'RVN', 'Ravencoin'],
  [0x80_00_00_b0, 'GBX', 'GoByte'],
  [0x80_00_00_b1, 'BTCZ', 'BitcoinZ'],
  [0x80_00_00_b2, 'POA', 'Poa'],
  [0x80_00_00_b3, 'NYC', 'NewYorkCoin'],
  [0x80_00_00_b4, 'MXT', 'MarteXcoin'],
  [0x80_00_00_b5, 'WC', 'Wincoin'],
  [0x80_00_00_b6, 'MNX', 'Minexcoin'],
  [0x80_00_00_b7, 'BTCP', 'Bitcoin Private'],
  [0x80_00_00_b8, 'MUSIC', 'Musicoin'],
  [0x80_00_00_b9, 'BCA', 'Bitcoin Atom'],
  [0x80_00_00_ba, 'CRAVE', 'Crave'],
  [0x80_00_00_bb, 'STAK', 'STRAKS'],
  [0x80_00_00_bc, 'WBTC', 'World Bitcoin'],
  [0x80_00_00_bd, 'LCH', 'LiteCash'],
  [0x80_00_00_be, 'EXCL', 'ExclusiveCoin'],
  [0x80_00_00_bf, '', 'Lynx'],
  [0x80_00_00_c0, 'LCC', 'LitecoinCash'],
  [0x80_00_00_c1, 'XFE', 'Feirm'],
  [0x80_00_00_c2, 'EOS', 'EOS'],
  [0x80_00_00_c3, 'TRX', 'Tron'],
  [0x80_00_00_c4, 'KOBO', 'Kobocoin'],
  [0x80_00_00_c5, 'HUSH', 'HUSH'],
  [0x80_00_00_c6, 'BANANO', 'Bananos'],
  [0x80_00_00_c7, 'ETF', 'ETF'],
  [0x80_00_00_c8, 'OMNI', 'Omni'],
  [0x80_00_00_c9, 'BIFI', 'BitcoinFile'],
  [0x80_00_00_ca, 'UFO', 'Uniform Fiscal Object'],
  [0x80_00_00_cb, 'CNMC', 'Cryptonodes'],
  [0x80_00_00_cc, 'BCN', 'Bytecoin'],
  [0x80_00_00_cd, 'RIN', 'Ringo'],
  [0x80_00_00_ce, 'ATP', 'Alaya'],
  [0x80_00_00_cf, 'EVT', 'everiToken'],
  [0x80_00_00_d0, 'ATN', 'ATN'],
  [0x80_00_00_d1, 'BIS', 'Bismuth'],
  [0x80_00_00_d2, 'NEET', 'NEETCOIN'],
  [0x80_00_00_d3, 'BOPO', 'BopoChain'],
  [0x80_00_00_d4, 'OOT', 'Utrum'],
  [0x80_00_00_d5, 'ALIAS', 'Alias'],
  [0x80_00_00_d6, 'MONK', 'Monkey Project'],
  [0x80_00_00_d7, 'BOXY', 'BoxyCoin'],
  [0x80_00_00_d8, 'FLO', 'Flo'],
  [0x80_00_00_d9, 'MEC', 'Megacoin'],
  [0x80_00_00_da, 'BTDX', 'BitCloud'],
  [0x80_00_00_db, 'XAX', 'Artax'],
  [0x80_00_00_dc, 'ANON', 'ANON'],
  [0x80_00_00_dd, 'LTZ', 'LitecoinZ'],
  [0x80_00_00_de, 'BITG', 'Bitcoin Green'],
  [0x80_00_00_df, 'ICP', 'Internet Computer (DFINITY)'],
  [0x80_00_00_e0, 'SMART', 'Smartcash'],
  [0x80_00_00_e1, 'XUEZ', 'XUEZ'],
  [0x80_00_00_e2, 'HLM', 'Helium'],
  [0x80_00_00_e3, 'WEB', 'Webchain'],
  [0x80_00_00_e4, 'ACM', 'Actinium'],
  [0x80_00_00_e5, 'NOS', 'NOS Stable Coins'],
  [0x80_00_00_e6, 'BITC', 'BitCash'],
  [0x80_00_00_e7, 'HTH', 'Help The Homeless Coin'],
  [0x80_00_00_e8, 'TZC', 'Trezarcoin'],
  [0x80_00_00_e9, 'VAR', 'Varda'],
  [0x80_00_00_ea, 'IOV', 'IOV'],
  [0x80_00_00_eb, 'FIO', 'FIO'],
  [0x80_00_00_ec, 'BSV', 'BitcoinSV'],
  [0x80_00_00_ed, 'DXN', 'DEXON'],
  [0x80_00_00_ee, 'QRL', 'Quantum Resistant Ledger'],
  [0x80_00_00_ef, 'PCX', 'ChainX'],
  [0x80_00_00_f0, 'LOKI', 'Loki'],
  [0x80_00_00_f1, '', 'Imagewallet'],
  [0x80_00_00_f2, 'NIM', 'Nimiq'],
  [0x80_00_00_f3, 'SOV', 'Sovereign Coin'],
  [0x80_00_00_f4, 'JCT', 'Jibital Coin'],
  [0x80_00_00_f5, 'SLP', 'Simple Ledger Protocol'],
  [0x80_00_00_f6, 'EWT', 'Energy Web'],
  [0x80_00_00_f7, 'UC', 'Ulord'],
  [0x80_00_00_f8, 'EXOS', 'EXOS'],
  [0x80_00_00_f9, 'ECA', 'Electra'],
  [0x80_00_00_fa, 'SOOM', 'Soom'],
  [0x80_00_00_fb, 'XRD', 'Redstone'],
  [0x80_00_00_fc, 'FREE', 'FreeCoin'],
  [0x80_00_00_fd, 'NPW', 'NewPowerCoin'],
  [0x80_00_00_fe, 'BST', 'BlockStamp'],
  [0x80_00_00_ff, '', 'SmartHoldem'],
  [0x80_00_01_00, 'NANO', 'Bitcoin Nano'],
  [0x80_00_01_01, 'BTCC', 'Bitcoin Core'],
  [0x80_00_01_02, '', 'Zen Protocol'],
  [0x80_00_01_03, 'ZEST', 'Zest'],
  [0x80_00_01_04, 'ABT', 'ArcBlock'],
  [0x80_00_01_05, 'PION', 'Pion'],
  [0x80_00_01_06, 'DT3', 'DreamTeam3'],
  [0x80_00_01_07, 'ZBUX', 'Zbux'],
  [0x80_00_01_08, 'KPL', 'Kepler'],
  [0x80_00_01_09, 'TPAY', 'TokenPay'],
  [0x80_00_01_0a, 'ZILLA', 'ChainZilla'],
  [0x80_00_01_0b, 'ANK', 'Anker'],
  [0x80_00_01_0c, 'BCC', 'BCChain'],
  [0x80_00_01_0d, 'HPB', 'HPB'],
  [0x80_00_01_0e, 'ONE', 'ONE'],
  [0x80_00_01_0f, 'SBC', 'SBC'],
  [0x80_00_01_10, 'IPC', 'IPChain'],
  [0x80_00_01_11, 'DMTC', 'Dominantchain'],
  [0x80_00_01_12, 'OGC', 'Onegram'],
  [0x80_00_01_13, 'SHIT', 'Shitcoin'],
  [0x80_00_01_14, 'ANDES', 'Andescoin'],
  [0x80_00_01_15, 'AREPA', 'Arepacoin'],
  [0x80_00_01_16, 'BOLI', 'Bolivarcoin'],
  [0x80_00_01_17, 'RIL', 'Rilcoin'],
  [0x80_00_01_18, 'HTR', 'Hathor Network'],
  [0x80_00_01_19, 'FCTID', 'Factom ID'],
  [0x80_00_01_1a, 'BRAVO', 'BRAVO'],
  [0x80_00_01_1b, 'ALGO', 'Algorand'],
  [0x80_00_01_1c, 'BZX', 'Bitcoinzero'],
  [0x80_00_01_1d, 'GXX', 'GravityCoin'],
  [0x80_00_01_1e, 'HEAT', 'HEAT'],
  [0x80_00_01_1f, 'XDN', 'DigitalNote'],
  [0x80_00_01_20, 'FSN', 'FUSION'],
  [0x80_00_01_21, 'CPC', 'Capricoin'],
  [0x80_00_01_22, 'BOLD', 'Bold'],
  [0x80_00_01_23, 'IOST', 'IOST'],
  [0x80_00_01_24, 'TKEY', 'Tkeycoin'],
  [0x80_00_01_25, 'USE', 'Usechain'],
  [0x80_00_01_26, 'BCZ', 'BitcoinCZ'],
  [0x80_00_01_27, 'IOC', 'Iocoin'],
  [0x80_00_01_28, 'ASF', 'Asofe'],
  [0x80_00_01_29, 'MASS', 'MASS'],
  [0x80_00_01_2a, 'FAIR', 'FairCoin'],
  [0x80_00_01_2b, 'NUKO', 'Nekonium'],
  [0x80_00_01_2c, 'GNX', 'Genaro Network'],
  [0x80_00_01_2d, 'DIVI', 'Divi Project'],
  [0x80_00_01_2e, 'CMT', 'Community'],
  [0x80_00_01_2f, 'EUNO', 'EUNO'],
  [0x80_00_01_30, 'IOTX', 'IoTeX'],
  [0x80_00_01_31, 'ONION', 'DeepOnion'],
  [0x80_00_01_32, '8BIT', '8Bit'],
  [0x80_00_01_33, 'ATC', 'AToken Coin'],
  [0x80_00_01_34, 'BTS', 'Bitshares'],
  [0x80_00_01_35, 'CKB', 'Nervos CKB'],
  [0x80_00_01_36, 'UGAS', 'Ultrain'],
  [0x80_00_01_37, 'ADS', 'Adshares'],
  [0x80_00_01_38, 'ARA', 'Aura'],
  [0x80_00_01_39, 'ZIL', 'Zilliqa'],
  [0x80_00_01_3a, 'MOAC', 'MOAC'],
  [0x80_00_01_3b, 'SWTC', 'SWTC'],
  [0x80_00_01_3c, 'VNSC', 'vnscoin'],
  [0x80_00_01_3d, 'PLUG', 'Pl^g'],
  [0x80_00_01_3e, 'MAN', 'Matrix AI Network'],
  [0x80_00_01_3f, 'ECC', 'ECCoin'],
  [0x80_00_01_40, 'RPD', 'Rapids'],
  [0x80_00_01_41, 'RAP', 'Rapture'],
  [0x80_00_01_42, 'GARD', 'Hashgard'],
  [0x80_00_01_43, 'ZER', 'Zero'],
  [0x80_00_01_44, 'EBST', 'eBoost'],
  [0x80_00_01_45, 'SHARD', 'Shard'],
  [0x80_00_01_46, 'MRX', 'Metrix Coin'],
  [0x80_00_01_47, 'CMM', 'Commercium'],
  [0x80_00_01_48, 'BLOCK', 'Blocknet'],
  [0x80_00_01_49, 'AUDAX', 'AUDAX'],
  [0x80_00_01_4a, 'LUNA', 'Terra'],
  [0x80_00_01_4b, 'ZPM', 'zPrime'],
  [0x80_00_01_4c, 'KUVA', 'Kuva Utility Note'],
  [0x80_00_01_4d, 'MEM', 'MemCoin'],
  [0x80_00_01_4e, 'CS', 'Credits'],
  [0x80_00_01_4f, 'SWIFT', 'SwiftCash'],
  [0x80_00_01_50, 'FIX', 'FIX'],
  [0x80_00_01_51, 'CPC', 'CPChain'],
  [0x80_00_01_52, 'VGO', 'VirtualGoodsToken'],
  [0x80_00_01_53, 'DVT', 'DeVault'],
  [0x80_00_01_54, 'N8V', 'N8VCoin'],
  [0x80_00_01_55, 'MTNS', 'OmotenashiCoin'],
  [0x80_00_01_56, 'BLAST', 'BLAST'],
  [0x80_00_01_57, 'DCT', 'DECENT'],
  [0x80_00_01_58, 'AUX', 'Auxilium'],
  [0x80_00_01_59, 'USDP', 'USDP'],
  [0x80_00_01_5a, 'HTDF', 'HTDF'],
  [0x80_00_01_5b, 'YEC', 'Ycash'],
  [0x80_00_01_5c, 'QLC', 'QLC Chain'],
  [0x80_00_01_5d, 'TEA', 'Icetea Blockchain'],
  [0x80_00_01_5e, 'ARW', 'ArrowChain'],
  [0x80_00_01_5f, 'MDM', 'Medium'],
  [0x80_00_01_60, 'CYB', 'Cybex'],
  [0x80_00_01_61, 'LTO', 'LTO Network'],
  [0x80_00_01_62, 'DOT', 'Polkadot'],
  [0x80_00_01_63, 'AEON', 'Aeon'],
  [0x80_00_01_64, 'RES', 'Resistance'],
  [0x80_00_01_65, 'AYA', 'Aryacoin'],
  [0x80_00_01_66, 'DAPS', 'Dapscoin'],
  [0x80_00_01_67, 'CSC', 'CasinoCoin'],
  [0x80_00_01_68, 'VSYS', 'V Systems'],
  [0x80_00_01_69, 'NOLLAR', 'Nollar'],
  [0x80_00_01_6a, 'XNOS', 'NOS'],
  [0x80_00_01_6b, 'CPU', 'CPUchain'],
  [0x80_00_01_6c, 'LAMB', 'Lambda Storage Chain'],
  [0x80_00_01_6d, 'VCT', 'ValueCyber'],
  [0x80_00_01_6e, 'CZR', 'Canonchain'],
  [0x80_00_01_6f, 'ABBC', 'ABBC'],
  [0x80_00_01_70, 'HET', 'HET'],
  [0x80_00_01_71, 'XAS', 'Asch'],
  [0x80_00_01_72, 'VDL', 'Vidulum'],
  [0x80_00_01_73, 'MED', 'MediBloc'],
  [0x80_00_01_74, 'ZVC', 'ZVChain'],
  [0x80_00_01_75, 'VESTX', 'Vestx'],
  [0x80_00_01_76, 'DBT', 'DarkBit'],
  [0x80_00_01_77, 'SEOS', 'SuperEOS'],
  [0x80_00_01_78, 'MXW', 'Maxonrow'],
  [0x80_00_01_79, 'ZNZ', 'ZENZO'],
  [0x80_00_01_7a, 'XCX', 'XChain'],
  [0x80_00_01_7b, 'SOX', 'SonicX'],
  [0x80_00_01_7c, 'NYZO', 'Nyzo'],
  [0x80_00_01_7d, 'ULC', 'ULCoin'],
  [0x80_00_01_7e, 'RYO', 'Ryo Currency'],
  [0x80_00_01_7f, 'KAL', 'Kaleidochain'],
  [0x80_00_01_80, 'XSN', 'Stakenet'],
  [0x80_00_01_81, 'DOGEC', 'DogeCash'],
  [0x80_00_01_82, 'BMV', "Bitcoin Matteo's Vision"],
  [0x80_00_01_83, 'QBC', 'Quebecoin'],
  [0x80_00_01_84, 'IMG', 'ImageCoin'],
  [0x80_00_01_85, 'QOS', 'QOS'],
  [0x80_00_01_86, 'PKT', 'PKT'],
  [0x80_00_01_87, 'LHD', 'LitecoinHD'],
  [0x80_00_01_88, 'CENNZ', 'CENNZnet'],
  [0x80_00_01_89, 'HSN', 'Hyper Speed Network'],
  [0x80_00_01_8a, 'CRO', 'Crypto Chain'],
  [0x80_00_01_8b, 'UMBRU', 'Umbru'],
  [0x80_00_01_8c, 'EVER', 'Everscale'],
  [0x80_00_01_8d, 'NEAR', 'NEAR Protocol'],
  [0x80_00_01_8e, 'XPC', 'XPChain'],
  [0x80_00_01_8f, 'ZOC', '01coin'],
  [0x80_00_01_90, 'NIX', 'NIX'],
  [0x80_00_01_91, 'UC', 'Utopiacoin'],
  [0x80_00_01_92, 'GALI', 'Galilel'],
  [0x80_00_01_93, 'OLT', 'Oneledger'],
  [0x80_00_01_94, 'XBI', 'XBI'],
  [0x80_00_01_95, 'DONU', 'DONU'],
  [0x80_00_01_96, 'EARTHS', 'Earths'],
  [0x80_00_01_97, 'HDD', 'HDDCash'],
  [0x80_00_01_98, 'SUGAR', 'Sugarchain'],
  [0x80_00_01_99, 'AILE', 'AileCoin'],
  [0x80_00_01_9a, 'TENT', 'TENT'],
  [0x80_00_01_9b, 'TAN', 'Tangerine Network'],
  [0x80_00_01_9c, 'AIN', 'AIN'],
  [0x80_00_01_9d, 'MSR', 'Masari'],
  [0x80_00_01_9e, 'SUMO', 'Sumokoin'],
  [0x80_00_01_9f, 'ETN', 'Electroneum'],
  [0x80_00_01_a0, 'BYTZ', 'BYTZ'],
  [0x80_00_01_a1, 'WOW', 'Wownero'],
  [0x80_00_01_a2, 'XTNC', 'XtendCash'],
  [0x80_00_01_a3, 'LTHN', 'Lethean'],
  [0x80_00_01_a4, 'NODE', 'NodeHost'],
  [0x80_00_01_a5, 'AGM', 'Argoneum'],
  [0x80_00_01_a6, 'CCX', 'Conceal Network'],
  [0x80_00_01_a7, 'TNET', 'Title Network'],
  [0x80_00_01_a8, 'TELOS', 'TelosCoin'],
  [0x80_00_01_a9, 'AION', 'Aion'],
  [0x80_00_01_aa, 'BC', 'Bitcoin Confidential'],
  [0x80_00_01_ab, 'KTV', 'KmushiCoin'],
  [0x80_00_01_ac, 'ZCR', 'ZCore'],
  [0x80_00_01_ad, 'ERG', 'Ergo'],
  [0x80_00_01_ae, 'PESO', 'Criptopeso'],
  [0x80_00_01_af, 'BTC2', 'Bitcoin 2'],
  [0x80_00_01_b0, 'XRPHD', 'XRPHD'],
  [0x80_00_01_b1, 'WE', 'WE Coin'],
  [0x80_00_01_b2, 'KSM', 'Kusama'],
  [0x80_00_01_b3, 'PCN', 'Peepcoin'],
  [0x80_00_01_b4, 'NCH', 'NetCloth'],
  [0x80_00_01_b5, 'ICU', 'CHIPO'],
  [0x80_00_01_b6, 'LN', 'LINK'],
  [0x80_00_01_b7, 'DTP', 'DeVault Token Protocol'],
  [0x80_00_01_b8, 'BTCR', 'Bitcoin Royale'],
  [0x80_00_01_b9, 'AERGO', 'AERGO'],
  [0x80_00_01_ba, 'XTH', 'Dothereum'],
  [0x80_00_01_bb, 'LV', 'Lava'],
  [0x80_00_01_bc, 'PHR', 'Phore'],
  [0x80_00_01_bd, 'VITAE', 'Vitae'],
  [0x80_00_01_be, 'COCOS', 'Cocos-BCX'],
  [0x80_00_01_bf, 'DIN', 'Dinero'],
  [0x80_00_01_c0, 'SPL', 'Simplicity'],
  [0x80_00_01_c1, 'YCE', 'MYCE'],
  [0x80_00_01_c2, 'XLR', 'Solaris'],
  [0x80_00_01_c3, 'KTS', 'Klimatas'],
  [0x80_00_01_c4, 'DGLD', 'DGLD'],
  [0x80_00_01_c5, 'XNS', 'Insolar'],
  [0x80_00_01_c6, 'EM', 'EMPOW'],
  [0x80_00_01_c7, 'SHN', 'ShineBlocks'],
  [0x80_00_01_c8, 'SEELE', 'Seele'],
  [0x80_00_01_c9, 'AE', 'æternity'],
  [0x80_00_01_ca, 'ODX', 'ObsidianX'],
  [0x80_00_01_cb, 'KAVA', 'Kava'],
  [0x80_00_01_cc, 'GLEEC', 'GLEEC'],
  [0x80_00_01_cd, 'FIL', 'Filecoin'],
  [0x80_00_01_ce, 'RUTA', 'Rutanio'],
  [0x80_00_01_cf, 'CSDT', 'CSDT'],
  [0x80_00_01_d0, 'ETI', 'EtherInc'],
  [0x80_00_01_d1, 'ZSLP', 'Zclassic Simple Ledger Protocol'],
  [0x80_00_01_d2, 'ERE', 'EtherCore'],
  [0x80_00_01_d3, 'DX', 'DxChain Token'],
  [0x80_00_01_d4, 'CPS', 'Capricoin+'],
  [0x80_00_01_d5, 'BTH', 'Bithereum'],
  [0x80_00_01_d6, 'MESG', 'MESG'],
  [0x80_00_01_d7, 'FIMK', 'FIMK'],
  [0x80_00_01_d8, 'AR', 'Arweave'],
  [0x80_00_01_d9, 'OGO', 'Origo'],
  [0x80_00_01_da, 'ROSE', 'Oasis Network'],
  [0x80_00_01_db, 'BARE', 'BARE Network'],
  [0x80_00_01_dc, 'GLEEC', 'GleecBTC'],
  [0x80_00_01_dd, 'CLR', 'Color Coin'],
  [0x80_00_01_de, 'RNG', 'Ring'],
  [0x80_00_01_df, 'OLO', 'Tool Global'],
  [0x80_00_01_e0, 'PEXA', 'Pexa'],
  [0x80_00_01_e1, 'MOON', 'Mooncoin'],
  [0x80_00_01_e2, 'OCEAN', 'Ocean Protocol'],
  [0x80_00_01_e3, 'BNT', 'Bluzelle Native'],
  [0x80_00_01_e4, 'AMO', 'AMO Blockchain'],
  [0x80_00_01_e5, 'FCH', 'FreeCash'],
  [0x80_00_01_e6, 'LAT', 'PlatON'],
  [0x80_00_01_e7, 'COIN', 'Bitcoin Bank'],
  [0x80_00_01_e8, 'VEO', 'Amoveo'],
  [0x80_00_01_e9, 'CCA', 'Counos Coin'],
  [0x80_00_01_ea, 'GFN', 'Graphene'],
  [0x80_00_01_eb, 'BIP', 'Minter Network'],
  [0x80_00_01_ec, 'KPG', 'Kunpeng Network'],
  [0x80_00_01_ed, 'FIN', 'FINL Chain'],
  [0x80_00_01_ee, 'BAND', 'Band'],
  [0x80_00_01_ef, 'DROP', 'Dropil'],
  [0x80_00_01_f0, 'BHT', 'Bluehelix Chain'],
  [0x80_00_01_f1, 'LYRA', 'Scrypta'],
  [0x80_00_01_f2, 'CS', 'Credits'],
  [0x80_00_01_f3, 'RUPX', 'Rupaya'],
  [0x80_00_01_f4, 'THETA', 'Theta'],
  [0x80_00_01_f5, 'SOL', 'Solana'],
  [0x80_00_01_f6, 'THT', 'ThoughtAI'],
  [0x80_00_01_f7, 'CFX', 'Conflux'],
  [0x80_00_01_f8, 'KUMA', 'Kumacoin'],
  [0x80_00_01_f9, 'HASH', 'Provenance'],
  [0x80_00_01_fa, 'CSPR', 'Casper'],
  [0x80_00_01_fb, 'EARTH', 'EARTH'],
  [0x80_00_01_fc, 'EGLD', 'MultiversX'],
  [0x80_00_01_fd, 'CHI', 'Xaya'],
  [0x80_00_01_fe, 'KOTO', 'Koto'],
  [0x80_00_01_ff, 'OTC', 'θ'],
  [0x80_00_02_00, 'XRD', 'Radiant'],
  [0x80_00_02_01, 'SEELEN', 'Seele-N'],
  [0x80_00_02_02, 'AETH', 'AETH'],
  [0x80_00_02_03, 'DNA', 'Idena'],
  [0x80_00_02_04, 'VEE', 'Virtual Economy Era'],
  [0x80_00_02_05, 'SIERRA', 'SierraCoin'],
  [0x80_00_02_06, 'LET', 'Linkeye'],
  [0x80_00_02_07, 'BSC', 'Bitcoin Smart Contract'],
  [0x80_00_02_08, 'BTCV', 'BitcoinVIP'],
  [0x80_00_02_09, 'ABA', 'Dabacus'],
  [0x80_00_02_0a, 'SCC', 'StakeCubeCoin'],
  [0x80_00_02_0b, 'EDG', 'Edgeware'],
  [0x80_00_02_0c, 'AMS', 'AmsterdamCoin'],
  [0x80_00_02_0d, 'GOSS', 'GOSSIP Coin'],
  [0x80_00_02_0e, 'BU', 'BUMO'],
  [0x80_00_02_0f, 'GRAM', 'GRAM'],
  [0x80_00_02_10, 'YAP', 'Yapstone'],
  [0x80_00_02_11, 'SCRT', 'Secret Network'],
  [0x80_00_02_12, 'NOVO', 'Novo'],
  [0x80_00_02_13, 'GHOST', 'Ghost'],
  [0x80_00_02_14, 'HST', 'HST'],
  [0x80_00_02_15, 'PRJ', 'ProjectCoin'],
  [0x80_00_02_16, 'YOU', 'YOUChain'],
  [0x80_00_02_17, 'XHV', 'Haven Protocol'],
  [0x80_00_02_18, 'BYND', 'Beyondcoin'],
  [0x80_00_02_19, 'JOYS', 'Joys Digital'],
  [0x80_00_02_1a, 'VAL', 'Valorbit'],
  [0x80_00_02_1b, 'FLOW', 'Flow'],
  [0x80_00_02_1c, 'SMESH', 'Spacemesh Coin'],
  [0x80_00_02_1d, 'SCDO', 'SCDO'],
  [0x80_00_02_1e, 'IQS', 'IQ-Cash'],
  [0x80_00_02_1f, 'BIND', 'Compendia'],
  [0x80_00_02_20, 'COINEVO', 'Coinevo'],
  [0x80_00_02_21, 'SCRIBE', 'Scribe'],
  [0x80_00_02_22, 'HYN', 'Hyperion'],
  [0x80_00_02_23, 'BHP', 'BHP'],
  [0x80_00_02_24, 'BBC', 'BigBang Core'],
  [0x80_00_02_25, 'MKF', 'MarketFinance'],
  [0x80_00_02_26, 'XDC', 'XinFin'],
  [0x80_00_02_27, 'STR', 'Straightedge'],
  [0x80_00_02_28, 'SUM', 'Sumcoin'],
  [0x80_00_02_29, 'HBC', 'HuobiChain'],
  [0x80_00_02_2a, '---', 'reserved'],
  [0x80_00_02_2b, 'BCS', 'Bitcoin Smart'],
  [0x80_00_02_2c, 'KTS', 'Kratos'],
  [0x80_00_02_2d, 'LKR', 'Lkrcoin'],
  [0x80_00_02_2e, 'TAO', 'Tao'],
  [0x80_00_02_2f, 'XWC', 'Whitecoin'],
  [0x80_00_02_30, 'DEAL', 'DEAL'],
  [0x80_00_02_31, 'NTY', 'Nexty'],
  [0x80_00_02_32, 'TOP', 'TOP NetWork'],
  [0x80_00_02_33, '---', 'reserved'],
  [0x80_00_02_34, 'AG', 'Agoric'],
  [0x80_00_02_35, 'CICO', 'Coinicles'],
  [0x80_00_02_36, 'IRIS', 'Irisnet'],
  [0x80_00_02_37, 'NCG', 'Nine Chronicles'],
  [0x80_00_02_38, 'LRG', 'Large Coin'],
  [0x80_00_02_39, 'SERO', 'Super Zero Protocol'],
  [0x80_00_02_3a, 'BDX', 'Beldex'],
  [0x80_00_02_3b, 'CCXX', 'Counos X'],
  [0x80_00_02_3c, 'SLS', 'Saluscoin'],
  [0x80_00_02_3d, 'SRM', 'Serum'],
  [0x80_00_02_3e, '---', 'reserved'],
  [0x80_00_02_3f, 'VIVT', 'VIDT Datalink'],
  [0x80_00_02_40, 'BPS', 'BitcoinPoS'],
  [0x80_00_02_41, 'NKN', 'NKN'],
  [0x80_00_02_42, 'ICL', 'ILCOIN'],
  [0x80_00_02_43, 'BONO', 'Bonorum'],
  [0x80_00_02_44, 'PLC', 'PLATINCOIN'],
  [0x80_00_02_45, 'DUN', 'Dune'],
  [0x80_00_02_46, 'DMCH', 'Darmacash'],
  [0x80_00_02_47, 'CTC', 'Creditcoin'],
  [0x80_00_02_48, 'KELP', 'Haidai Network'],
  [0x80_00_02_49, 'GBCR', 'GoldBCR'],
  [0x80_00_02_4a, 'XDAG', 'XDAG'],
  [0x80_00_02_4b, 'PRV', 'Incognito Privacy'],
  [0x80_00_02_4c, 'SCAP', 'SafeCapital'],
  [0x80_00_02_4d, 'TFUEL', 'Theta Fuel'],
  [0x80_00_02_4e, 'GTM', 'Gentarium'],
  [0x80_00_02_4f, 'RNL', 'RentalChain'],
  [0x80_00_02_50, 'GRIN', 'Grin'],
  [0x80_00_02_51, 'MWC', 'MimbleWimbleCoin'],
  [0x80_00_02_52, 'DOCK', 'Dock'],
  [0x80_00_02_53, 'POLYX', 'Polymesh'],
  [0x80_00_02_54, 'DIVER', 'Divergenti'],
  [0x80_00_02_55, 'XEP', 'Electra Protocol'],
  [0x80_00_02_56, 'APN', 'Apron'],
  [0x80_00_02_57, 'TFC', 'Turbo File Coin'],
  [0x80_00_02_58, 'UTE', 'Unit-e'],
  [0x80_00_02_59, 'MTC', 'Metacoin'],
  [0x80_00_02_5a, 'NC', 'NobodyCash'],
  [0x80_00_02_5b, 'XINY', 'Xinyuehu'],
  [0x80_00_02_5c, 'DYN', 'Dynamo'],
  [0x80_00_02_5d, 'BUFS', 'Buffer'],
  [0x80_00_02_5e, 'STOS', 'Stratos'],
  [0x80_00_02_5f, 'TON', 'TON'],
  [0x80_00_02_60, 'TAFT', 'TAFT'],
  [0x80_00_02_61, 'HYDRA', 'HYDRA'],
  [0x80_00_02_62, 'NOR', 'Noir'],
  [0x80_00_02_63, '', 'Manta Network Private Asset'],
  [0x80_00_02_64, '', 'Calamari Network Private Asset'],
  [0x80_00_02_65, 'WCN', 'Widecoin'],
  [0x80_00_02_66, 'OPT', 'Optimistic Ethereum'],
  [0x80_00_02_67, 'PSWAP', 'PolkaSwap'],
  [0x80_00_02_68, 'VAL', 'Validator'],
  [0x80_00_02_69, 'XOR', 'Sora'],
  [0x80_00_02_6a, 'SSP', 'SmartShare'],
  [0x80_00_02_6b, 'DEI', 'DeimosX'],
  [0x80_00_02_6c, '---', 'reserved'],
  [0x80_00_02_6d, 'ZERO', 'Singularity'],
  [0x80_00_02_6e, 'ALPHA', 'AlphaDAO'],
  [0x80_00_02_6f, 'BDECO', 'BDCashProtocol Ecosystem'],
  [0x80_00_02_70, 'NOBL', 'Nobility'],
  [0x80_00_02_71, 'EAST', 'Eastcoin'],
  [0x80_00_02_72, 'KDA', 'Kadena'],
  [0x80_00_02_73, 'SOUL', 'Phantasma'],
  [0x80_00_02_74, 'LORE', 'Gitopia'],
  [0x80_00_02_75, 'FNR', 'Fincor'],
  [0x80_00_02_76, 'NEXUS', 'Nexus'],
  [0x80_00_02_77, 'QTZ', 'Quartz'],
  [0x80_00_02_78, 'XMA', 'Massa'],
  [0x80_00_02_79, 'CALL', 'Callchain'],
  [0x80_00_02_7a, 'VAL', 'Validity'],
  [0x80_00_02_7b, 'POKT', 'Pocket Network'],
  [0x80_00_02_7c, 'EMIT', 'EMIT'],
  [0x80_00_02_7d, 'APTOS', 'Aptos'],
  [0x80_00_02_7e, 'ADON', 'ADON'],
  [0x80_00_02_7f, 'BTSG', 'BitSong'],
  [0x80_00_02_80, 'LFC', 'Leofcoin'],
  [0x80_00_02_81, 'KCS', 'KuCoin Shares'],
  [0x80_00_02_82, 'KCC', 'KuCoin Community Chain'],
  [0x80_00_02_83, 'AZERO', 'Aleph Zero'],
  [0x80_00_02_84, 'TREE', 'Tree'],
  [0x80_00_02_85, 'LX', 'Lynx'],
  [0x80_00_02_86, 'XLN', 'Lunarium'],
  [0x80_00_02_87, 'CIC', 'CIC Chain'],
  [0x80_00_02_88, 'ZRB', 'Zarb'],
  [0x80_00_02_89, '---', 'reserved'],
  [0x80_00_02_8a, 'UCO', 'Archethic'],
  [0x80_00_02_8b, 'SFX', 'Safex Cash'],
  [0x80_00_02_8c, 'SFT', 'Safex Token'],
  [0x80_00_02_8d, 'WSFX', 'Wrapped Safex Cash'],
  [0x80_00_02_8e, 'USDG', 'US Digital Gold'],
  [0x80_00_02_8f, 'WMP', 'WAMP'],
  [0x80_00_02_93, 'KOIN', 'Koinos'],
  [0x80_00_02_94, 'PIRATE', 'PirateCash'],
  [0x80_00_02_97, 'SFRX', 'EtherGem Sapphire'],
  [0x80_00_02_9a, 'ACT', 'Achain'],
  [0x80_00_02_9b, 'PRKL', 'Perkle'],
  [0x80_00_02_9c, 'SSC', 'SelfSell'],
  [0x80_00_02_9d, 'GC', 'GateChain'],
  [0x80_00_02_9e, 'PLGR', 'Pledger'],
  [0x80_00_02_9f, 'MPLGR', 'Pledger'],
  [0x80_00_02_a0, 'KNOX', 'Knox'],
  [0x80_00_02_a1, 'ZED', 'ZED'],
  [0x80_00_02_a2, 'CNDL', 'Candle'],
  [0x80_00_02_a3, 'WLKR', 'Walker Crypto Innovation Index'],
  [0x80_00_02_a4, 'WLKRR', 'Walker'],
  [0x80_00_02_a5, 'YUNGE', 'Yunge'],
  [0x80_00_02_a6, 'Voken', 'Voken'],
  [0x80_00_02_a7, 'APL', 'Apollo'],
  [0x80_00_02_a8, 'Evrynet', 'Evrynet'],
  [0x80_00_02_a9, 'NENG', 'Nengcoin'],
  [0x80_00_02_aa, 'CHTA', 'Cheetahcoin'],
  [0x80_00_02_ad, 'OAS', 'Oasys'],
  [0x80_00_02_ae, 'KAR', 'Karura Network'],
  [0x80_00_02_b0, 'CET', 'CoinEx Chain'],
  [0x80_00_02_b2, 'KLV', 'KleverChain'],
  [0x80_00_02_b6, 'VTBC', 'VTB Community'],
  [0x80_00_02_ba, 'VEIL', 'Veil'],
  [0x80_00_02_bb, 'GTB', 'GotaBit'],
  [0x80_00_02_bc, 'XDAI', 'xDai'],
  [0x80_00_02_bd, 'COM', 'Commercio'],
  [0x80_00_02_be, 'CCC', 'Commercio Cash Credit'],
  [0x80_00_02_c3, 'MCOIN', 'Moneta Coin'],
  [0x80_00_02_c7, 'CHC', 'Chaincoin'],
  [0x80_00_02_c8, 'SERF', 'Serfnet'],
  [0x80_00_02_c9, 'XTL', 'Katal Chain'],
  [0x80_00_02_ca, 'BNB', 'Binance'],
  [0x80_00_02_cb, 'SIN', 'Sinovate'],
  [0x80_00_02_cc, 'DLN', 'Delion'],
  [0x80_00_02_cd, 'BONTE', 'Bontecoin'],
  [0x80_00_02_ce, 'PEER', 'Peer'],
  [0x80_00_02_d5, 'MCX', 'MultiCash'],
  [0x80_00_02_da, 'HEALIOS', 'Tenacity'],
  [0x80_00_02_db, 'BMK', 'Bitmark'],
  [0x80_00_02_de, 'DENTX', 'DENTNet'],
  [0x80_00_02_e1, 'ATOP', 'Financial Blockchain'],
  [0x80_00_02_eb, 'CFG', 'Centrifuge'],
  [0x80_00_02_ee, 'XPRT', 'Persistence'],
  [0x80_00_02_f1, '', 'Age Encryption'],
  [0x80_00_02_f5, 'HONEY', 'HoneyWood'],
  [0x80_00_03_00, 'BALLZ', 'Ballzcoin'],
  [0x80_00_03_02, 'COSA', 'Cosanta'],
  [0x80_00_03_03, 'BR', 'BR'],
  [0x80_00_03_07, 'PLSR', 'Pulsar Coin'],
  [0x80_00_03_08, 'KEY', 'Keymaker Coin'],
  [0x80_00_03_09, 'BTW', 'Bitcoin World'],
  [0x80_00_03_0c, 'PLCUC', 'PLC Ultima Classic'],
  [0x80_00_03_0d, 'PLCUX', 'PLC Ultima X'],
  [0x80_00_03_0e, 'PLCU', 'PLC Ultima'],
  [0x80_00_03_10, 'SUI', 'Sui'],
  [0x80_00_03_12, 'UIDD', 'UIDD'],
  [0x80_00_03_13, 'ACA', 'Acala'],
  [0x80_00_03_14, 'BNC', 'Bifrost'],
  [0x80_00_03_15, 'TAU', 'Lamden'],
  [0x80_00_03_1f, 'PDEX', 'Polkadex'],
  [0x80_00_03_20, 'BEET', 'Beetle Coin'],
  [0x80_00_03_21, 'DST', 'DSTRA'],
  [0x80_00_03_24, 'ZKS', 'zkSync'],
  [0x80_00_03_28, 'QVT', 'Qvolta'],
  [0x80_00_03_29, 'SDN', 'Shiden Network'],
  [0x80_00_03_2a, 'ASTR', 'Astar Network'],
  [0x80_00_03_2b, '---', 'reserved'],
  [0x80_00_03_2d, 'MEER', 'Qitmeer'],
  [0x80_00_03_32, 'VET', 'VeChain Token'],
  [0x80_00_03_33, 'REEF', 'Reef'],
  [0x80_00_03_34, 'CLO', 'Callisto'],
  [0x80_00_03_36, 'BDB', 'BigchainDB'],
  [0x80_00_03_3c, 'CCN', 'ComputeCoin'],
  [0x80_00_03_3f, 'CRUZ', 'cruzbit'],
  [0x80_00_03_40, 'SAPP', 'Sapphire'],
  [0x80_00_03_41, '777', 'Jackpot'],
  [0x80_00_03_42, 'KYAN', 'Kyanite'],
  [0x80_00_03_43, 'AZR', 'Azzure'],
  [0x80_00_03_44, 'CFL', 'CryptoFlow'],
  [0x80_00_03_45, 'DASHD', 'Dash Diamond'],
  [0x80_00_03_46, 'TRTT', 'Trittium'],
  [0x80_00_03_47, 'UCR', 'Ultra Clear'],
  [0x80_00_03_48, 'PNY', 'Peony'],
  [0x80_00_03_49, 'BECN', 'Beacon'],
  [0x80_00_03_4a, 'MONK', 'Monk'],
  [0x80_00_03_4b, 'SAGA', 'CryptoSaga'],
  [0x80_00_03_4c, 'SUV', 'Suvereno'],
  [0x80_00_03_4d, 'ESK', 'EskaCoin'],
  [0x80_00_03_4e, 'OWO', 'OneWorld Coin'],
  [0x80_00_03_4f, 'PEPS', 'PEPS Coin'],
  [0x80_00_03_50, 'BIR', 'Birake'],
  [0x80_00_03_51, 'MOBIC', 'MobilityCoin'],
  [0x80_00_03_52, 'FLS', 'Flits'],
  [0x80_00_03_54, 'DSM', 'Desmos'],
  [0x80_00_03_55, 'PRCY', 'PRCY Coin'],
  [0x80_00_03_5a, 'HVH', 'HAVAH'],
  [0x80_00_03_62, 'MOB', 'MobileCoin'],
  [0x80_00_03_64, 'IF', 'Infinitefuture'],
  [0x80_00_03_6d, 'NAM', 'Namada'],
  [0x80_00_03_70, 'LUM', 'Lum Network'],
  [0x80_00_03_73, 'ZBC', 'ZooBC'],
  [0x80_00_03_76, 'ADF', 'AD Token'],
  [0x80_00_03_78, 'NEO', 'NEO'],
  [0x80_00_03_79, 'TOMO', 'TOMO'],
  [0x80_00_03_7a, 'XSEL', 'Seln'],
  [0x80_00_03_80, 'LKSC', 'LKSCoin'],
  [0x80_00_03_82, 'AS', 'Assetchain'],
  [0x80_00_03_83, 'XEC', 'eCash'],
  [0x80_00_03_84, 'LMO', 'Lumeneo'],
  [0x80_00_03_85, 'NXT', 'NxtMeta'],
  [0x80_00_03_88, 'HNT', 'Helium'],
  [0x80_00_03_8b, 'FIS', 'StaFi'],
  [0x80_00_03_8d, 'SGE', 'Saage'],
  [0x80_00_03_8f, 'GERT', 'Gert'],
  [0x80_00_03_94, 'META', 'Metadium'],
  [0x80_00_03_95, 'FRA', 'Findora'],
  [0x80_00_03_97, 'CCD', 'Concordium'],
  [0x80_00_03_99, 'AVN', 'Avian Network'],
  [0x80_00_03_9d, 'DIP', 'Dipper Network'],
  [0x80_00_03_a0, 'GHM', 'HermitMatrixNetwork'],
  [0x80_00_03_a3, 'RUNE', 'THORChain (RUNE)'],
  [0x80_00_03_ad, '---', 'reserved'],
  [0x80_00_03_bb, 'LTP', 'LifetionCoin'],
  [0x80_00_03_be, '', 'KickSoccer'],
  [0x80_00_03_c0, 'VKAX', 'Vkax'],
  [0x80_00_03_c6, 'MATIC', 'Matic'],
  [0x80_00_03_c8, 'UNW', 'UNW'],
  [0x80_00_03_ca, 'TWINS', 'TWINS'],
  [0x80_00_03_d1, 'TLOS', 'Telos'],
  [0x80_00_03_d5, 'TAFECO', 'Taf ECO Chain'],
  [0x80_00_03_d9, 'AU', 'Autonomy'],
  [0x80_00_03_db, 'VCG', 'VipCoin'],
  [0x80_00_03_dc, 'XAZAB', 'Xazab core'],
  [0x80_00_03_dd, 'AIOZ', 'AIOZ'],
  [0x80_00_03_de, 'CORE', 'Coreum'],
  [0x80_00_03_df, 'PEC', 'Phoenix'],
  [0x80_00_03_e0, 'UNT', 'Unit'],
  [0x80_00_03_e1, 'XRB', 'X Currency'],
  [0x80_00_03_e2, 'QUAI', 'Quai Network'],
  [0x80_00_03_e3, 'CAPS', 'Ternoa'],
  [0x80_00_03_e4, 'OKT', 'OKChain Token'],
  [0x80_00_03_e5, 'SUM', 'Solidum'],
  [0x80_00_03_e6, 'LBTC', 'Lightning Bitcoin'],
  [0x80_00_03_e7, 'BCD', 'Bitcoin Diamond'],
  [0x80_00_03_e8, 'BTN', 'Bitcoin New'],
  [0x80_00_03_e9, 'TT', 'ThunderCore'],
  [0x80_00_03_ea, 'BKT', 'BanKitt'],
  [0x80_00_03_eb, 'NODL', 'Nodle'],
  [0x80_00_03_ec, 'PCOIN', 'PCOIN'],
  [0x80_00_03_ed, 'TAO', 'Bittensor'],
  [0x80_00_03_ef, 'FTM', 'Fantom'],
  [0x80_00_03_f0, 'RPG', 'RPG'],
  [0x80_00_03_f2, 'HT', 'Huobi ECO Chain'],
  [0x80_00_03_f3, 'ELV', 'Eluvio'],
  [0x80_00_03_f5, 'BIC', 'Beincrypto'],
  [0x80_00_03_fc, 'EVC', 'Evrice'],
  [0x80_00_03_fe, 'XRD', 'Radix DLT'],
  [0x80_00_03_ff, 'ONE', 'HARMONY-ONE'],
  [0x80_00_04_00, 'ONT', 'Ontology'],
  [0x80_00_04_01, 'CZZ', 'Classzz'],
  [0x80_00_04_02, 'KEX', 'Kira Exchange Token'],
  [0x80_00_04_03, 'MCM', 'Mochimo'],
  [0x80_00_04_08, 'BTCR', 'BTCR'],
  [0x80_00_04_12, 'MFID', 'Moonfish ID'],
  [0x80_00_04_57, 'BBC', 'Big Bitcoin'],
  [0x80_00_04_60, 'RISE', 'RISE'],
  [0x80_00_04_62, 'CMT', 'CyberMiles Token'],
  [0x80_00_04_68, 'ETSC', 'Ethereum Social'],
  [0x80_00_04_69, 'DFI', 'DeFiChain'],
  [0x80_00_04_6a, 'DFI', 'DeFiChain EVM Network'],
  [0x80_00_04_71, '$DAG', 'Constellation Labs'],
  [0x80_00_04_79, 'CDY', 'Bitcoin Candy'],
  [0x80_00_04_83, 'EFI', 'Efinity'],
  [0x80_00_04_92, 'HOO', 'Hoo Smart Chain'],
  [0x80_00_04_d2, 'ALPH', 'Alephium'],
  [0x80_00_04_d5, '', 'Nostr'],
  [0x80_00_05_04, 'GLMR', 'Moonbeam'],
  [0x80_00_05_05, 'MOVR', 'Moonriver'],
  [0x80_00_05_1c, 'WEI', 'WEI'],
  [0x80_00_05_39, 'DFC', 'Defcoin'],
  [0x80_00_05_75, 'HYC', 'Hycon'],
  [0x80_00_05_82, 'TENTSLP', 'TENT Simple Ledger Protocol'],
  [0x80_00_05_e6, 'XSC', 'XT Smart Chain'],
  [0x80_00_05_e8, 'AAC', 'Double-A Chain'],
  [0x80_00_05_f4, '', 'Taler'],
  [0x80_00_05_fd, 'BEAM', 'Beam'],
  [0x80_00_06_50, 'ELF', 'AELF'],
  [0x80_00_06_52, 'AUDL', 'AUDL'],
  [0x80_00_06_54, 'ATH', 'Atheios'],
  [0x80_00_06_5b, 'LUME', 'Lume Web'],
  [0x80_00_06_6a, 'NEW', 'Newton'],
  [0x80_00_06_79, 'BTA', 'Btachain'],
  [0x80_00_06_98, 'BCX', 'BitcoinX'],
  [0x80_00_06_c1, 'XTZ', 'Tezos'],
  [0x80_00_06_f0, 'LBTC', 'Liquid BTC'],
  [0x80_00_06_f1, 'BBP', 'Biblepay'],
  [0x80_00_06_f8, 'JPYS', 'JPY Stablecoin'],
  [0x80_00_06_fd, 'VEGA', 'Vega Protocol'],
  [0x80_00_07_17, 'ADA', 'Cardano'],
  [0x80_00_07_1a, 'CUBE', 'Cube Chain Native Token'],
  [0x80_00_07_43, 'TES', 'Teslacoin'],
  [0x80_00_07_60, 'ZTX', 'Zetrix'],
  [0x80_00_07_6b, 'XEC', 'eCash token'],
  [0x80_00_07_6d, 'CLC', 'Classica'],
  [0x80_00_07_7f, 'VIPS', 'VIPSTARCOIN'],
  [0x80_00_07_86, 'CITY', 'City Coin'],
  [0x80_00_07_a3, 'XX', 'xx coin'],
  [0x80_00_07_b9, 'XMX', 'Xuma'],
  [0x80_00_07_c0, 'TRTL', 'TurtleCoin'],
  [0x80_00_07_c1, 'SLRT', 'Solarti Chain'],
  [0x80_00_07_c2, 'QTH', 'Qing Tong Horizon'],
  [0x80_00_07_c3, 'EGEM', 'EtherGem'],
  [0x80_00_07_c4, 'MIRA', 'Mira Chain'],
  [0x80_00_07_c5, 'HODL', 'HOdlcoin'],
  [0x80_00_07_c6, 'PHL', 'Placeholders'],
  [0x80_00_07_c7, 'SC', 'Sia'],
  [0x80_00_07_cc, 'MYT', 'Mineyourtime'],
  [0x80_00_07_cd, 'POLIS', 'Polis'],
  [0x80_00_07_ce, 'XMCC', 'Monoeci'],
  [0x80_00_07_cf, 'COLX', 'ColossusXT'],
  [0x80_00_07_d0, 'GIN', 'GinCoin'],
  [0x80_00_07_d1, 'MNP', 'MNPCoin'],
  [0x80_00_07_d2, 'MLN', 'Miraland'],
  [0x80_00_07_e1, 'KIN', 'Kin'],
  [0x80_00_07_e2, 'EOSC', 'EOSClassic'],
  [0x80_00_07_e3, 'GBT', 'GoldBean Token'],
  [0x80_00_07_e4, 'PKC', 'PKC'],
  [0x80_00_07_e5, 'SKT', 'Sukhavati'],
  [0x80_00_07_e6, 'XHT', 'Xinghuo Token'],
  [0x80_00_08_00, 'MCASH', 'MCashChain'],
  [0x80_00_08_01, 'TRUE', 'TrueChain'],
  [0x80_00_08_26, 'KILT', 'KILT Spiritnet'],
  [0x80_00_08_3d, 'SAMA', 'Exosama Network'],
  [0x80_00_08_40, 'IoTE', 'IoTE'],
  [0x80_00_08_59, 'XRG', 'Ergon'],
  [0x80_00_08_88, 'CHZ', 'Chiliz'],
  [0x80_00_08_ad, 'ASK', 'ASK'],
  [0x80_00_08_ed, '', 'Qiyi Chain'],
  [0x80_00_08_fd, 'QTUM', 'QTUM'],
  [0x80_00_08_fe, 'ETP', 'Metaverse'],
  [0x80_00_08_ff, 'GXC', 'GXChain'],
  [0x80_00_09_00, 'CRP', 'CranePay'],
  [0x80_00_09_01, 'ELA', 'Elastos'],
  [0x80_00_09_22, 'SNOW', 'Snowblossom'],
  [0x80_00_09_3d, 'XIN', 'Mixin'],
  [0x80_00_0a_0a, 'AOA', 'Aurora'],
  [0x80_00_0a_9e, 'NAS', 'Nebulas'],
  [0x80_00_0b_4e, 'REOSC', 'REOSC Ecosystem'],
  [0x80_00_0b_7d, 'BND', 'Blocknode'],
  [0x80_00_0b_bb, 'LUX', 'LUX'],
  [0x80_00_0b_d6, 'HBAR', 'Hedera HBAR'],
  [0x80_00_0c_05, 'COS', 'Contentos'],
  [0x80_00_0c_cc, 'CCC', 'CodeChain'],
  [0x80_00_0d_05, 'SXP', 'Solar'],
  [0x80_00_0d_31, 'ROI', 'ROIcoin'],
  [0x80_00_0d_35, 'DYN', 'Dynamic'],
  [0x80_00_0d_37, 'SEQ', 'Sequence'],
  [0x80_00_0d_e0, 'DEO', 'Destocoin'],
  [0x80_00_0d_ec, 'DST', 'DeStream'],
  [0x80_00_0e_11, 'CY', 'Cybits'],
  [0x80_00_0f_c8, 'FC8', 'FCH Network'],
  [0x80_00_10_00, 'YEE', 'YeeCo'],
  [0x80_00_10_7a, 'IOTA', 'IOTA'],
  [0x80_00_10_7b, 'SMR', 'Shimmer'],
  [0x80_00_10_92, 'AXE', 'Axe'],
  [0x80_00_10_f7, 'XYM', 'Symbol'],
  [0x80_00_11_5c, 'C4E', 'Chain4Energy'],
  [0x80_00_13_37, 'XVM', 'Venidium'],
  [0x80_00_13_8e, 'SBC', 'Senior Blockchain'],
  [0x80_00_14_80, 'FIC', 'FIC'],
  [0x80_00_14_e9, 'HNS', 'Handshake'],
  [0x80_00_15_1c, 'ISK', 'ISKRA'],
  [0x80_00_15_5b, 'ALTME', 'ALTME'],
  [0x80_00_15_b3, 'FUND', 'Unification'],
  [0x80_00_16_7d, 'STX', 'Stacks'],
  [0x80_00_17_07, 'VOW', 'VowChain VOW'],
  [0x80_00_17_20, 'SLU', 'SILUBIUM'],
  [0x80_00_17_ac, 'GO', 'GoChain GO'],
  [0x80_00_18_1e, 'MOI', 'My Own Internet'],
  [0x80_00_19_c7, 'RSC', 'Royal Sports City'],
  [0x80_00_1a_0a, 'BPA', 'Bitcoin Pizza'],
  [0x80_00_1a_20, 'SAFE', 'SAFE'],
  [0x80_00_1a_7b, 'COTI', 'COTI'],
  [0x80_00_1b_39, 'ROGER', 'TheHolyrogerCoin'],
  [0x80_00_1b_b3, 'TOPL', 'Topl'],
  [0x80_00_1c_a3, 'KLY', 'KLYNTAR'],
  [0x80_00_1c_ad, 'SHFT', 'Shyft'],
  [0x80_00_1e_61, 'BTV', 'Bitvote'],
  [0x80_00_1f_40, 'SKY', 'Skycoin'],
  [0x80_00_1f_90, '', 'DSRV'],
  [0x80_00_20_00, 'PAC', 'pacprotocol'],
  [0x80_00_20_19, 'KLAY', 'KLAY'],
  [0x80_00_20_93, 'BTQ', 'BitcoinQuark'],
  [0x80_00_20_fc, 'XCH', 'Chia'],
  [0x80_00_21_48, '---', 'reserved'],
  [0x80_00_21_e8, 'PLMNT', 'Planetmint'],
  [0x80_00_22_b8, 'SBTC', 'Super Bitcoin'],
  [0x80_00_23_04, 'NULS', 'NULS'],
  [0x80_00_23_25, 'BBC', 'Babacoin'],
  [0x80_00_23_26, 'JGC', 'JagoanCoin'],
  [0x80_00_23_27, 'BTP', 'Bitcoin Pay'],
  [0x80_00_23_28, 'AVAX', 'Avalanche'],
  [0x80_00_23_29, 'ARB1', 'Arbitrum'],
  [0x80_00_23_2a, 'BOBA', 'Boba'],
  [0x80_00_23_2b, 'LOOP', 'Loopring'],
  [0x80_00_23_2c, 'STRK', 'StarkNet'],
  [0x80_00_23_2d, 'AVAXC', 'Avalanche C-Chain'],
  [0x80_00_23_2e, 'BSC', 'Binance Smart Chain'],
  [0x80_00_26_45, 'NRG', 'Energi'],
  [0x80_00_26_a0, 'BTF', 'Bitcoin Faith'],
  [0x80_00_27_0f, 'GOD', 'Bitcoin God'],
  [0x80_00_27_10, 'FO', 'FIBOS'],
  [0x80_00_27_f2, 'RTM', 'Raptoreum'],
  [0x80_00_28_33, 'XRC', 'XRhodium'],
  [0x80_00_29_6d, 'XPI', 'Lotus'],
  [0x80_00_2b_67, 'ESS', 'Essentia One'],
  [0x80_00_30_39, 'IPOS', 'IPOS'],
  [0x80_00_31_2a, 'MINA', 'Mina'],
  [0x80_00_33_33, 'BTY', 'BitYuan'],
  [0x80_00_33_34, 'YCC', 'Yuan Chain Coin'],
  [0x80_00_36_b1, 'WAX', 'Worldwide Asset Exchange'],
  [0x80_00_3d_e5, 'SDGO', 'SanDeGo'],
  [0x80_00_3f_35, 'XTX', 'Totem Live Network'],
  [0x80_00_41_72, 'ARDR', 'Ardor'],
  [0x80_00_46_50, 'MTR', 'Meter'],
  [0x80_00_4a_dd, 'SAFE', 'Safecoin'],
  [0x80_00_4a_df, 'FLUX', 'Flux'],
  [0x80_00_4a_e1, 'RITO', 'Ritocoin'],
  [0x80_00_4e_44, 'XND', 'ndau'],
  [0x80_00_52_0c, 'C4EI', 'c4ei'],
  [0x80_00_55_80, 'PCT', 'Pactus'],
  [0x80_00_57_e8, 'PWR', 'PWRcoin'],
  [0x80_00_62_a4, 'BELL', 'Bellcoin'],
  [0x80_00_64_76, 'CHX', 'Own'],
  [0x80_00_72_27, 'NEXA', 'Nexa'],
  [0x80_00_75_31, '---', 'reserved'],
  [0x80_00_79_7e, 'ESN', 'EtherSocial Network'],
  [0x80_00_7a_69, '', 'ThePower'],
  [0x80_00_82_88, 'TEO', 'Trust Eth reOrigin'],
  [0x80_00_84_56, 'BTCS', 'Bitcoin Stake'],
  [0x80_00_88_88, 'BTT', 'ByteTrade'],
  [0x80_00_94_68, 'FXTC', 'FixedTradeCoin'],
  [0x80_00_99_99, 'AMA', 'Amabig'],
  [0x80_00_a4_55, 'FACT', 'FACT0RN'],
  [0x80_00_a8_14, 'AXIV', 'AXIV'],
  [0x80_00_c0_6e, 'EVE', 'evan'],
  [0x80_00_c0_c0, 'STASH', 'STASH'],
  [0x80_00_ce_10, 'CELO', 'Celo'],
  [0x80_00_f0_b0, 'TH', 'TianHe'],
  [0x80_01_00_00, 'KETH', 'Krypton World'],
  [0x80_01_0f_2c, 'GRLC', 'Garlicoin'],
  [0x80_01_11_77, 'GWL', 'Gewel'],
  [0x80_01_2f_d1, 'ZYN', 'Wethio'],
  [0x80_01_5b_38, 'RYO', 'c0ban'],
  [0x80_01_86_9f, 'WICC', 'Waykichain'],
  [0x80_01_88_94, 'HOME', 'HomeCoin'],
  [0x80_01_8a_92, 'STC', 'Starcoin'],
  [0x80_01_9a_91, 'STRAX', 'Strax'],
  [0x80_01_b2_07, 'KAS', 'Kaspa'],
  [0x80_02_78_0b, 'APTA', 'Bloqs4Good'],
  [0x80_03_0f_b1, 'AKA', 'Akroma'],
  [0x80_01_10_00, 'GENOM', 'GENOM'],
  [0x80_03_c3_01, 'ATS', 'ARTIS sigma1'],
  [0x80_03_fc_0b, 'ZAMA', 'Zama'],
  [0x80_04_cb_2f, 'PI', 'Pi Network'],
  [0x80_05_16_14, 'VALUE', 'Value Chain'],
  [0x80_05_16_15, '3333', 'Pi Value Consensus'],
  [0x80_06_79_32, 'X42', 'x42'],
  [0x80_08_27_50, 'SCR', 'Scroll'],
  [0x80_0a_2c_2a, 'VITE', 'Vite'],
  [0x80_0d_90_38, 'SEA', 'Second Exchange Alliance'],
  [0x80_10_00_00, 'AMAX', 'Armonia Meta Chain'],
  [0x80_11_df_89, 'ILT', 'iOlite'],
  [0x80_14_09_5a, 'ETHO', 'Etho Protocol'],
  [0x80_14_0a_dc, 'XERO', 'Xerom'],
  [0x80_1a_20_10, 'LAX', 'LAPO'],
  [0x80_3b_e0_2b, 'EPK', 'EPIK Protocol'],
  [0x80_48_59_44, 'HYD', 'Hydra Token'],
  [0x80_50_19_49, 'BCO', 'BitcoinOre'],
  [0x80_50_19_4a, 'BHD', 'BitcoinHD'],
  [0x80_50_54_4e, 'PTN', 'PalletOne'],
  [0x80_56_4c_58, 'VLX', 'Velas'],
  [0x80_57_41_4e, 'WAN', 'Wanchain'],
  [0x80_57_9b_fc, 'WAVES', 'Waves'],
  [0x80_57_9b_fd, 'WEST', 'Waves Enterprise'],
  [0x80_61_62_63, 'ABC', 'Abcmint'],
  [0x80_63_72_6d, 'CRM', 'Creamcoin'],
  [0x80_73_65_6d, 'SEM', 'Semux'],
  [0x80_73_79_78, 'ION', 'ION'],
  [0x80_76_ad_f1, 'FCT', 'FirmaChain'],
  [0x80_77_67_72, 'WGR', 'WGR'],
  [0x80_77_67_73, 'OBSR', 'OBServer'],
  [0x80_7c_8f_c7, 'AFS', 'ANFS'],
  [0x80_e6_b2_80, 'XDS', 'XDS'],
  [0x83_ad_bc_39, 'AQUA', 'Aquachain'],
  [0x85_4c_56_38, 'HATCH', 'Hatch'],
  [0x85_7a_b1_e1, 'kUSD', 'kUSD'],
  [0x85_f5_e0_fc, 'GENS', 'GENS'],
  [0x85_f5_e0_fd, 'EQ', 'EQ'],
  [0x85_f5_e0_fe, 'FLUID', 'Fluid Chains'],
  [0x85_f5_e0_ff, 'QKC', 'QuarkChain'],
  [0xa4_46_56_44, 'FVDC', 'ForumCoin'],
  [0xc6_55_45_4c, '', 'Fuel'],
]
